module.exports = __webpack_public_path__ + "static/img/1.52069c7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/5/eng/1.png
// module id = A7Pe
// module chunks = 0